import { jsx as r } from "react/jsx-runtime";
import { createSvgIcon as l } from "@mui/material";
const t = l(
  /* @__PURE__ */ r(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 4c4.4183 0 8 3.5817 8 8s-3.5817 8-8 8-8-3.5817-8-8 3.5817-8 8-8m0-2c5.5228 0 10 4.4772 10 10s-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2m-1 5v7h2V7zm1 8c.5523 0 1 .4477 1 1s-.4477 1-1 1-1-.4477-1-1 .4477-1 1-1",
      clipRule: "evenodd"
    }
  ),
  "Alert"
), n = l(
  /* @__PURE__ */ r("path", { fill: "currentColor", d: "M16.59 8.295 12 12.875l-4.59-4.58L6 9.705l6 6 6-6z" }),
  "ChevronDown"
), c = l(
  /* @__PURE__ */ r("path", { fill: "currentColor", d: "m9.705 6-1.41 1.41 4.58 4.59-4.58 4.59L9.705 18l6-6z" }),
  "ChevronRight"
), i = l(
  [
    /* @__PURE__ */ r("circle", { cx: "12", cy: "12", r: "9", fill: "none", stroke: "currentColor", strokeWidth: "2" }, "0"),
    /* @__PURE__ */ r("path", { fill: "currentColor", d: "M13 17h-2v-7h2z" }, "1"),
    /* @__PURE__ */ r("rect", { width: "2", height: "2", x: "13", y: "9", fill: "currentColor", rx: "1", transform: "rotate(-180 13 9)" }, "2")
  ],
  "Info"
), h = l(
  /* @__PURE__ */ r(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20 12c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8 3.5817-8 8-8 8 3.5817 8 8m2 0c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10M8.7575 14.8997l-2.2014-2.2014 1.4142-1.4142 2.2014 2.2014 5.6568-5.6568 1.4143 1.4142-7.0711 7.0711z",
      clipRule: "evenodd"
    }
  ),
  "TickCircleOutline"
), s = l(
  /* @__PURE__ */ r("path", { fill: "currentColor", d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z" }),
  "Warning"
);
export {
  t as A,
  c as C,
  i as I,
  h as T,
  s as W,
  n as a
};
//# sourceMappingURL=Warning-RmgMSYCd.js.map
